export const MORE_STRINGS = {
  TUTORIAL_TITLE: 'Tutorial',
  SUPPORT_TITLE: 'Support',
};
